module.exports = __webpack_public_path__ + "static/img/图层38.7854ad7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层38.png
// module id = sNkU
// module chunks = 0